import React from 'react'
import { User } from 'firebase'
import { useParams } from 'react-router-dom'
import { RiderForm } from './rider-form'
import { FirestoreDocument } from '@react-firebase/firestore'
import { firebaseApp } from '../firebase/firebase'

export function EditRider({ user }: { user: User }) {
  const { id } = useParams<any>()
  const docPath = `users/${user.uid}/riders/${id}`
  return (
    <FirestoreDocument path={docPath}>
      {(d) =>
        d.isLoading ? (
          'Loading'
        ) : d.value ? (
          <RiderForm
            rider={d.value}
            onSave={async (rider) => await firebaseApp.firestore().doc(docPath).update(rider)}
          />
        ) : (
          `No rider found with id ${id}`
        )
      }
    </FirestoreDocument>
  )
}
